export const config = {
  url_proxy_openlayers: '/proxyOpenLayers.php?',
  url_wms: '/ows/wms',
  geocodificador: '/geocodificador',
  search: '/search',
  url_getGML: '/admin/server/getGML',
  EPSG: 'EPSG:25831',
  EPSG_mapa: 'EPSG:3857',
  EPSG_lonLat: 'EPSG:4326',
  url_tipus_via: '/ows',
  url_owsseg_wms: '/owsseg/wms',
  url_owsseg_wfs: '/owsseg/wfs',

  //PRE
  url_owsWFS: '/ows/wfs',

  //DVP
  //url_owsWFS: 'https://sig.pre.intranet.gencat.cat/ows/wfs',

  capabilities_version: '1.3.0',
  url_getMapList: '/admin/server/mapa/list',
  url_getUser: '/login/admin/server/administracio/getCurrentUser/',
  url_checkLogin: '/login/admin/server/administracio/checkUserLogin',
  url_userMaps: '/login/admin/server/mapa/listMapViewer',
  url_saveMap: '/admin/server/mapa/saveViewerMap',
  url_saveUserMap: '/login/admin/server/mapa/saveViewerMap',
  url_removeViewer: '/admin/server/mapa/removeViewer/',
  url_visorConf: '/admin/server/visorInternet/getConfiguracio/',
  url_getMap: '/admin/server/mapa/getWMC/',
  url_getUserMap: '/login/admin/server/mapa/getWMCViewer/',
  version_2_0: '2.0.0',
  url_getExport: '/admin/server/mapa/getExportFile',

  //PRE
  url_getCatalog: '/admin/server/mapa/getWMCCatalogJSON/',
  url_getCatalogUser: '/login/admin/server/mapa/getWMCCatalogJSON/',
  url_getCatalogID: '/visorHipermapa/getCatalogID.php',

  //DVP
  // url_getCatalog: 'https://sig.pre.intranet.gencat.cat/admin/server/mapa/getWMCCatalogJSON/',
  // url_getCatalogUser: 'https://sig.pre.intranet.gencat.cat/login/admin/server/mapa/getWMCCatalogJSON/',
  // url_getCatalogID: 'https://sig.pre.intranet.gencat.cat/visorHipermapa/getCatalogID.php',

  // URL para obtener el email de usuarios loggeados
  url_getUserEmail: '/login/admin/server/administracio/getCurrentEmail/', // PRE
  // url_getUserEmail: 'https://giscorp.sitep.cat/admin/server/administracio/getCurrentEmail/', //DVP

  //URL para obtener la mida limite de las capas a descargar
  url_getLimitLayerSize: '/admin/server/mapa/getLimitLayerSize/',

  url_solrPRE: '/search/direct',
  url_downloadMap: '/admin/server/ServletFileDownloadWMC',
  url_solrPRO: '/searchNew/direct',
  url_extenal: '/manteniment/wmc/wmc_catalog.xml',
  url_fitxaPDF: '/generate_fitxa.php',
  url_ServletFileDownloadDataRaster: '/admin/server/servletFileDownloadDataRaster',
  url_wss: '/ws/wss_1.0 HTTP/1.1',
  url_icc: 'www.icc.cat',
  url_metadata: '/metadades/geonetworkMetadataDetailUuid.html?uuid=',
  icc_localitzaPK: 'http://www.icc.cat/geocodificador/ws/wss_1.0#localitzaPK',
  icc_localitzaAdreca: 'http://www.icc.cat/geocodificador/ws/wss_1.0#localitzaAdreca',
  icc_localitzaToponim: 'http://www.icc.cat/geocodificador/ws/wss_1.0#localitzaToponim',
  icc_infoPunt: 'http://www.icc.cat/geocodificador/ws/wss_1.0#obtenirInfoPunt',
  url_enquesta: 'https://territori.gencat.cat/ca/01_departament/formularis/hipermapa-versio-2/index.html',
  accessibilitatUrl: 'https://web.gencat.cat/ca/ajuda/accessibilitat/',
  avisLegalUrl: 'https://web.gencat.cat/ca/ajuda/avis_legal/',
  sobreGencatUrl: 'https://web.gencat.cat/ca/ajuda/sobre_gencat/',
  politicaGaletesUrl: 'https://web.gencat.cat/ca/ajuda/politica-de-galetes/',
  anticHipermapaUrl: 'https://sig.gencat.cat/visors/hipermapa_antic.html',
  url_realDecreto: 'https://www.boe.es/diario_boe/txt.php?id=BOE-A-2018-12699',
  url_contingutAccessible: 'https://web.gencat.cat/ca/tramits/tramits-temes/Continguts-accessibles-al-web',
  url_solicitaInfo: 'https://web.gencat.cat/ca/tramits/tramits-temes/Continguts-accessibles-al-web?moda=1',
  url_reclamaSolicitud: 'https://web.gencat.cat/ca/tramits/tramits-temes/Continguts-accessibles-al-web?category=&moda=2',
  idHipermapa: '261',
  // idHipermapa: '221',
  idIntranet: '1'
};

//LOCAL

//HARDCODED
// export const config = {
//   url_proxy_openlayers: 'http://192.122.214.87/proxyOpenLayers.php?',
//   url_wms: 'http://192.122.214.87/ows/wms',
//   geocodificador: 'http://192.122.214.87/geocodificador',
//   search: 'http://192.122.214.87/search',
//   url_getGML: 'http://192.122.214.87/admin/server/getGML',
//   EPSG: 'EPSG:25831',
//   EPSG_mapa: 'EPSG:3857',
//   EPSG_lonLat: 'EPSG:4326',
//   url_tipus_via: 'http://192.122.214.87/ows',
//   url_owsseg_wms: 'http://192.122.214.87/owsseg/wms',
//   url_owsseg_wfs: 'http://192.122.214.87/owsseg/wfs',

//   //de momento no
//   //url_owsWFS: 'http://192.122.214.87/ows/wfs',
//   //DVP
//   url_owsWFS: 'https://sig.pre.intranet.gencat.cat/ows/wfs',

//   capabilities_version: '1.3.0',
//   url_downloadMap: 'https://sig.pre.intranet.gencat.cat/admin/server/ServletFileDownloadWMC',
//   url_getMapList: 'https://sig.pre.intranet.gencat.cat/admin/server/mapa/list',
//   url_getUser: 'https://sig.pre.intranet.gencat.cat/login/admin/server/administracio/getCurrentUser/',
//   url_checkLogin: 'https://sig.pre.intranet.gencat.cat/login/admin/server/administracio/checkUserLogin',

//   // URL para obtener el email de usuarios loggeados
//   // url_getUserEmail: 'https://sig.pre.intranet.gencat.cat/login/admin/server/administracio/getCurrentEmail/', // PRE
//   url_getUserEmail: 'https://giscorp.sitep.cat/admin/server/administracio/getCurrentEmail/', //DVP

//   url_userMaps: 'https://sig.pre.intranet.gencat.cat/login/admin/server/mapa/listMapViewer',
//   url_saveMap: 'https://sig.pre.intranet.gencat.cat/admin/server/mapa/saveViewerMap',
//   url_saveUserMap: 'https://sig.pre.intranet.gencat.cat/login/admin/server/mapa/saveViewerMap',
//   url_removeViewer: 'https://sig.pre.intranet.gencat.cat/admin/server/mapa/removeViewer/',
//   url_extenal: 'https://sig.pre.intranet.gencat.cat/manteniment/wmc/wmc_catalog.xml',
//   url_visorConf: '/login/admin/server/visorInternet/getConfiguracio/',
//   url_getMap: 'https://sig.pre.intranet.gencat.cat/admin/server/mapa/getWMC/',
//   url_getUserMap: 'https://sig.pre.intranet.gencat.cat/login/admin/server/mapa/getWMCViewer/',
//   version_2_0: '2.0.0',

//   //url_getExport: 'https://192.122.214.87/admin/server/getExportFileFME',
//   url_getExport: 'https://giscorp.sitep.cat/admin/server/getExportFileFME',

//   // url_getCatalog: 'http://192.122.214.87/admin/server/mapa/getWMCCatalogJSON/',
//   // url_getCatalogUser: 'http://192.122.214.87/admin/server/mapa/getWMCCatalogJSON/',
//   // url_getCatalogID: 'http://192.122.214.87/nouHipermapa/getCatalogID.php',
//   url_getCatalog: 'https://sig.pre.intranet.gencat.cat/admin/server/mapa/getWMCCatalogJSON/',
//   url_getCatalogUser: 'https://sig.pre.intranet.gencat.cat/login/admin/server/mapa/getWMCCatalogJSON/',
//   url_getCatalogID: 'https://sig.pre.intranet.gencat.cat/visorHipermapa/getCatalogID.php',

//   url_solrPRE: 'http://192.122.214.87/search/direct',
//   url_solrPRO: 'http://192.122.214.87/searchNew/direct',
//   url_fitxaPDF: 'http://192.122.214.87/generate_fitxa.php',
//   url_ServletFileDownloadDataRaster: 'http://192.122.214.87/admin/server/servletFileDownloadDataRaster',
//   url_wss: 'http://192.122.214.87/ws/wss_1.0 HTTP/1.1',
//   url_icc: 'www.icc.cat',
//   url_metadata: '/metadades/geonetworkMetadataDetailUuid.html?uuid=',
//   icc_localitzaPK: 'http://www.icc.cat/geocodificador/ws/wss_1.0#localitzaPK',
//   icc_localitzaAdreca: 'http://www.icc.cat/geocodificador/ws/wss_1.0#localitzaAdreca',
//   icc_localitzaToponim: 'http://www.icc.cat/geocodificador/ws/wss_1.0#localitzaToponim',
//   icc_infoPunt: 'http://www.icc.cat/geocodificador/ws/wss_1.0#obtenirInfoPunt',
//   url_enquesta: 'https://territori.gencat.cat/ca/01_departament/formularis/hipermapa-versio-2/index.html',
//   accessibilitatUrl: 'https://web.gencat.cat/ca/ajuda/accessibilitat/',
//   avisLegalUrl: 'https://web.gencat.cat/ca/ajuda/avis_legal/',
//   sobreGencatUrl: 'https://web.gencat.cat/ca/ajuda/sobre_gencat/',
//   politicaGaletesUrl: 'https://web.gencat.cat/ca/ajuda/politica-de-galetes/',
//   anticHipermapaUrl: 'https://sig.gencat.cat/visors/hipermapa_antic.html',
//   url_realDecreto: 'https://www.boe.es/diario_boe/txt.php?id=BOE-A-2018-12699',
//   url_contingutAccessible: 'https://web.gencat.cat/ca/tramits/tramits-temes/Continguts-accessibles-al-web',
//   url_solicitaInfo: 'https://web.gencat.cat/ca/tramits/tramits-temes/Continguts-accessibles-al-web?moda=1',
//   url_reclamaSolicitud: 'https://web.gencat.cat/ca/tramits/tramits-temes/Continguts-accessibles-al-web?category=&moda=2',
//   idHipermapa: '221',
//   idIntranet: '1'
// };
